
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ContentForm } from "../ContentForm";
import { ContentFormData, FormSubmissionState } from "../types";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { AlertCircle } from "lucide-react";

interface AddContentCardProps {
  newContent: ContentFormData;
  onContentChange: (content: ContentFormData) => void;
  onFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onThumbnailChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onAddContent: () => void;
  submissionState: FormSubmissionState;
}

export function AddContentCard({
  newContent,
  onContentChange,
  onFileChange,
  onThumbnailChange,
  onAddContent,
  submissionState
}: AddContentCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Προσθήκη Περιεχομένου</CardTitle>
      </CardHeader>
      <CardContent>
        {submissionState.error && (
          <Alert variant="destructive" className="mb-4">
            <AlertCircle className="h-4 w-4" />
            <AlertDescription>{submissionState.error}</AlertDescription>
          </Alert>
        )}
        <ContentForm
          newContent={newContent}
          onContentChange={onContentChange}
          onFileChange={onFileChange}
          onThumbnailChange={onThumbnailChange}
          onAddContent={onAddContent}
          isSubmitting={submissionState.isSubmitting}
        />
      </CardContent>
    </Card>
  );
}
